import "./Home.css"
import {Job} from "../components/Job";
import React from "react";
import {Link} from "react-router-dom";

export const Home = () => {
  return <>
        <h1> Job opportunities in Leuven</h1>
        <div className="job-list">
          <Link to="/cplusplus"><Job title="R&D Junior / Senior Software Engineer"/></Link>
          <Link to="/intern"><Job title="R&D internship (Dutch)"/></Link>
        </div>
  </>
}